import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";

/* -------- packages -------- */
import { Container, Spinner } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { clearDepartmentErrors, fetchDepartmentRequest, updateDepartmentRequest } from "../../store/actions";
/* ------------------------- */

/* -------- intern functions -------- */
import { hasAllRights } from "../../utils/userTools";
/* ------------------------- */

/* -------- components -------- */
import Breadcrumb from "../../components/ui/Breadcrumbs";
import DynamicForm from "../../components/ui/Form";
import { getActivities, getErrorFromResponse } from '../../utils/utils';
import ErrorHandler from '../../components/ui/Error/ErrorHandler';
/* ------------------------- */


export default function DepartmentNewEditPage() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const parameters = useSelector(state => state.Parameters);

  document.title = `${t('departments')} | ${parameters.appName}`; //meta title
  
  const { id } = useParams(); // Get the id from the URL  

  const { department, loadingDepartment, errorDepartment } = useSelector(state => state.Departments);
  const { sectors } = useSelector(state => state.Sectors);
  const { agencies } = useSelector(state => state.Agencies);

  const [formattedSectors, setFormattedSectors] = useState([]);
  const [formattedAgencies, setFormattedAgencies] = useState([]);

  useEffect(() => {
    if (id && !isNaN(id)) {
      dispatch(fetchDepartmentRequest(id));
    }
  }, [dispatch]);


  useEffect(() => {
    if (sectors) {
      let newSectors = sectors.map((sector) => {
        return {
          id: sector.id,
          value: sector.lib,
          label: sector.lib
        }
      });
      setFormattedSectors(newSectors);
    }
  }, [sectors]);

  useEffect(() => {
    if (agencies) {
      let newAgencies = agencies.map((agency) => {
        return {
          id: agency.id,
          value: agency.lib,
          label: agency.lib
        }
      });
      setFormattedAgencies(newAgencies);
    }
  }, [agencies]);

  ErrorHandler(errorDepartment, clearDepartmentErrors);

  const fields = [
    { key: 'lib', type: 'text', required: true },
    { key: 'code', type: 'number', required: false, isDisabled: true},
    { key: 'sectorId', type: 'select', required: true, options: formattedSectors, isId: true },
    { key: 'agencyId', type: 'select', required: true, options: formattedAgencies, isId: true},
  ];
      
    const disposition = [
      ['lib', 'code'],
      ['sectorId', "agencyId"],
  ];

  
  useEffect(() => {
    const preloader = document.getElementById("preloader");
    const status = document.getElementById("status");
    
    if (loadingDepartment) {
      if (preloader) preloader.style.display = "block";
      if (status) status.style.display = "block";
    } else {
      if (preloader) preloader.style.display = "none";
      if (status) status.style.display = "none";
    }
  }, [loadingDepartment]);
  
  return (
      <div className="page-content vh-100 overflow-auto">
        <Container fluid>
          <Breadcrumb title={t("department")} breadcrumbItem={t("department")} url={"/departments"}/>
          <DynamicForm
            fields={fields} 
            initialValues={id && !isNaN(id) ? (department || {}) : {}} 
            editFunction={updateDepartmentRequest}
            isEdit={id}
            isLoading={loadingDepartment}
            error={errorDepartment} // Pass the error to DynamicForm
            prefListName={"department"}
            disposition={disposition}
          />
        </Container>
        <ToastContainer />
      </div>
  );
};

